import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const NoAuthGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn) {
    // redirection selon le rôle
    const profile = authService.profile;

    if (profile === 'SUPER_ADMIN') {
      router.navigate(['/admin-global']);
    } else if (profile === 'ADMIN_ENTREPRISE') {
      router.navigate(['/admin-entreprise']);
    } else {
      router.navigate(['/salarie']);
    }
    return false;
  }

  return true;
};
